import { render, staticRenderFns } from "./UpdatePrompt.vue?vue&type=template&id=529968b5&scoped=true&"
import script from "./UpdatePrompt.vue?vue&type=script&lang=js&"
export * from "./UpdatePrompt.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePrompt.vue?vue&type=style&index=0&id=529968b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529968b5",
  null
  
)

export default component.exports